import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const section = new Restful(project, 'section')

section.download = function() {
  const url = project + 'section/download'
  return http.octetget(url).then(res => {
    res.url = window.URL.createObjectURL(res.file)
    return res
  })
}

section.import = function(data) {
  const url = project + 'section/import'
  return http.post(url, data).then(res => {
    return res
  })
}

section.getProcess = function(id) {
  const url = project + 'section/progress/' + id
  return http.get(url).then(res => {
    return res
  })
}
export default section
